/** Financeiro → Contas a receber. Wrapper fino de ContasView (kind='receber'). */
import ContasView from './ContasView.jsx'

export default function ContasReceber() {
  return <ContasView kind="receber" />
}
